(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["convertx-media-card"] && !Shopify.designMode) return;
  try {
    
  window.__convertxPhosphorLoaded ||= false;
  if (!window.__convertxPhosphorLoaded) {
    window.__convertxPhosphorLoaded = true;
    var head = document.getElementsByTagName('head')[0];
    for (const weight of ['regular', 'thin', 'light', 'bold', 'fill', 'duotone']) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = `https://cdn.jsdelivr.net/npm/@phosphor-icons/web@2.1.2/src/${weight}/style.css`;
      head.appendChild(link);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["convertx-sections-divider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.convertx-sections-divider');
    if (!sections.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const parseSeconds = (raw) => {
      const normalized = String(raw || '').trim();
      if (!normalized) return 18;
      if (normalized.endsWith('ms')) return Number.parseFloat(normalized) / 1000;
      return Number.parseFloat(normalized);
    };

    const setMorphDurations = (section, shouldPause) => {
      const styles = window.getComputedStyle(section);
      const baseSpeed = clamp(parseSeconds(styles.getPropertyValue('--convertx-divider-speed')), 1, 120);
      const morphs = section.querySelectorAll('.convertx-sections-divider__morph');

      morphs.forEach((morph, index) => {
        const isReverse = morph.classList.contains('convertx-sections-divider__morph--reverse');
        const baseFactor = isReverse ? 1.18 : 1;
        const zigzagFactor = section.classList.contains('convertx-sections-divider--zigzag_soft') ? 0.88 : 1;
        const phaseOffset = index % 2 === 0 ? 1 : 1.06;
        const duration = clamp(baseSpeed * baseFactor * zigzagFactor * phaseOffset, 2.5, 90);
        morph.setAttribute('dur', `${duration.toFixed(2)}s`);
      });

      section.querySelectorAll('.convertx-sections-divider__svg').forEach((svg) => {
        if (shouldPause) {
          svg.pauseAnimations();
        } else {
          svg.unpauseAnimations();
        }
      });
    };

    const syncSectionAnimations = () => {
      sections.forEach((section) => {
        const styles = window.getComputedStyle(section);
        const state = styles.getPropertyValue('--convertx-divider-animation-state').trim();
        const shouldPause = reducedMotion.matches || state !== 'running';
        setMorphDurations(section, shouldPause);
      });
    };

    syncSectionAnimations();
    reducedMotion.addEventListener('change', syncSectionAnimations);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', syncSectionAnimations);
      document.addEventListener('shopify:section:reorder', syncSectionAnimations);
      document.addEventListener('shopify:section:select', syncSectionAnimations);
      document.addEventListener('shopify:section:deselect', syncSectionAnimations);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
